function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(2.6667 0 0 2.6667 -.0004504 -5.1498e-7)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "m20 0h-16a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h2.9l4.451 3.763a1 1 0 0 0 1.292 0l4.457-3.763h2.9a4 4 0 0 0 4-4v-12a4 4 0 0 0-4-4zm2 16a2 2 0 0 1-2 2h-2.9a2 2 0 0 0-1.291 0.473l-3.809 3.217-3.807-3.217a2 2 0 0 0-1.293-0.473h-2.9a2 2 0 0 1-2-2v-12a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 7h5a1 1 0 0 0 0-2h-5a1 1 0 0 0 0 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 9h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17 13h-10a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2z"
}));
function SvgCommentAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAlt);
export default __webpack_public_path__ + "static/media/comment-alt.9b7e3285.svg";
export { ForwardRef as ReactComponent };